<div class="dialog-wrapper">
  <p class="congrats-text">
    Coming Soon!
  </p>
</div>